import React from 'react';
const { Icon, Card, Button, Avatar } = window;
/* ============================================================
   BOOKER — Tela: Acessos (só admin)
   Aprova/revoga contas Microsoft, define papel (Admin/Operador) e mostra a
   trilha de logs. Regras: admin não revoga/rebaixa outro admin nem a si mesmo.
   ============================================================ */
var { useState, useEffect } = React;

const fmtData = (iso) => { try { return new Date(iso).toLocaleDateString('pt-BR'); } catch { return '—'; } };
const fmtDataHora = (iso) => { try { return new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }); } catch { return '—'; } };

const PAPEL_COR = {
  admin: { cor: 'var(--booker-orange)', bg: 'var(--warn-bg)', label: 'Admin' },
  operador: { cor: 'var(--info)', bg: 'var(--info-bg)', label: 'Operador' },
};
const STATUS_COR = {
  ativo: { cor: 'var(--ok)', bg: 'var(--info-bg)', label: 'Ativo' },
  pendente: { cor: 'var(--booker-orange)', bg: 'var(--warn-bg)', label: 'Pendente' },
  revogado: { cor: 'var(--danger)', bg: 'var(--danger-bg)', label: 'Revogado' },
};
// como cada ação do log aparece
const ACAO_INFO = {
  login: { txt: 'Entrou', cor: 'var(--ok)', icon: 'check' },
  pedido: { txt: 'Solicitou acesso', cor: 'var(--booker-orange)', icon: 'user' },
  aprovado: { txt: 'Aprovado', cor: 'var(--ok)', icon: 'check' },
  revogado: { txt: 'Revogado', cor: 'var(--danger)', icon: 'x' },
  papel: { txt: 'Mudou papel', cor: 'var(--info)', icon: 'settings' },
  migracao: { txt: 'Sistema', cor: 'var(--text-muted)', icon: 'settings' },
};

const Badge = ({ map, k }) => {
  const c = map[k] || { cor: 'var(--text-muted)', bg: 'var(--surface-inset)', label: k || '—' };
  return <span style={{ fontSize: 11.5, fontWeight: 800, color: c.cor, background: c.bg, padding: '3px 10px', borderRadius: 99 }}>{c.label}</span>;
};

function Usuarios({ account }) {
  const [lista, setLista] = useState([]);
  const [logs, setLogs] = useState([]);
  const [estado, setEstado] = useState('carregando'); // carregando | ok | erro
  const [erro, setErro] = useState('');
  const [aprovando, setAprovando] = useState({}); // papel escolhido por linha pendente/revogada

  async function carregar() {
    setEstado('carregando'); setErro('');
    try {
      const [u, l] = await Promise.all([window.Api.apiUsersList(), window.Api.apiAcessosLogs().catch(() => [])]);
      setLista(u); setLogs(l); setEstado('ok');
      if (window.recarregarPendentes) window.recarregarPendentes(); // atualiza o badge do menu

    } catch (e) { setErro(e.message); setEstado('erro'); }
  }
  useEffect(() => { carregar(); }, []);

  async function aprovar(u, papel) {
    try { await window.Api.apiUserAprovar(u.id, papel); carregar(); }
    catch (e) { window.avisar(e.message); }
  }
  async function revogar(u) {
    if (!await window.confirmar(`Revogar o acesso de "${u.nome}"? Ele não vai mais conseguir entrar (pode ser reaprovado depois).`)) return;
    try { await window.Api.apiUserRevogar(u.id); carregar(); }
    catch (e) { window.avisar(e.message); }
  }
  async function mudarPapel(u, papel) {
    try { await window.Api.apiUserPapel(u.id, papel); carregar(); }
    catch (e) { window.avisar(e.message); carregar(); }
  }

  const pendentes = lista.filter(u => u.status === 'pendente').length;

  const selPapel = (u) => (
    <select value={aprovando[u.id] || 'operador'} onChange={e => setAprovando(a => ({ ...a, [u.id]: e.target.value }))}
      style={{ padding: '5px 10px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface)', color: 'var(--text-strong)', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>
      <option value="operador">como Operador</option>
      <option value="admin">como Admin</option>
    </select>
  );

  return (
    <div style={{ animation: 'fadeUp .4s ease both' }}>
      <div style={{ marginBottom: 22 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: 'var(--text-strong)', letterSpacing: '-.02em' }}>Acessos</h1>
        <p style={{ margin: '5px 0 0', color: 'var(--text-muted)', fontSize: 14 }}>
          Login pela conta Microsoft · quem entra é aprovado aqui · {estado === 'ok' ? `${lista.length} conta(s)` : '…'}
          {pendentes > 0 && <span style={{ marginLeft: 8, fontWeight: 800, color: 'var(--booker-orange)' }}>· {pendentes} aguardando aprovação</span>}
        </p>
      </div>

      {estado === 'carregando' && <Card pad={40} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Carregando…</Card>}

      {estado === 'erro' && (
        <Card pad={24} style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <span style={{ width: 42, height: 42, borderRadius: 11, background: 'var(--danger-bg)', color: 'var(--danger)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="alert" size={20} /></span>
          <div style={{ flex: 1 }}><div style={{ fontSize: 14.5, fontWeight: 700, color: 'var(--text-strong)' }}>Não foi possível carregar</div><div style={{ fontSize: 13, color: 'var(--text-muted)' }}>{erro}</div></div>
          <Button variant="default" onClick={carregar}>Tentar de novo</Button>
        </Card>
      )}

      {estado === 'ok' && (
        <Card pad={0} style={{ overflow: 'hidden', marginBottom: 22 }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 760 }}>
              <thead><tr style={{ borderBottom: '1px solid var(--border)' }}>
                {['Conta', 'Papel', 'Status', 'Último acesso', 'Ações'].map((h, i) => (
                  <th key={i} style={{ textAlign: i === 4 ? 'right' : 'left', padding: '14px 16px', fontSize: 11.5, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.05em' }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {lista.map((u) => {
                  const eu = account && u.email === account.email;
                  const ativo = u.status === 'ativo';
                  const admin = u.papel === 'admin';
                  return (
                    <tr key={u.id} style={{ borderTop: '1px solid var(--border)', background: u.status === 'pendente' ? 'var(--warn-bg)' : 'transparent' }}>
                      <td style={{ padding: '13px 16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
                          <Avatar name={u.nome} size={36} />
                          <div>
                            <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--text-strong)' }}>{u.nome} {eu && <span style={{ fontSize: 11, color: 'var(--text-faint)', fontWeight: 600 }}>(você)</span>}</div>
                            <div className="mono" style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{u.email}</div>
                          </div>
                        </div>
                      </td>
                      <td style={{ padding: '13px 16px' }}>
                        {/* Papel: só editável se ATIVO, não é você, e não é admin (admin é "sticky") */}
                        {ativo && !eu && !admin ? (
                          <select value={u.papel || 'operador'} onChange={(e) => mudarPapel(u, e.target.value)} title="Mudar papel"
                            style={{ padding: '4px 11px', borderRadius: 99, border: '1px solid var(--border-strong)', background: 'var(--surface)', color: 'var(--text-strong)', fontSize: 12, fontWeight: 800, cursor: 'pointer' }}>
                            <option value="operador">Operador</option>
                            <option value="admin">Admin</option>
                          </select>
                        ) : u.papel ? <Badge map={PAPEL_COR} k={u.papel} /> : <span style={{ fontSize: 12, color: 'var(--text-faint)' }}>—</span>}
                      </td>
                      <td style={{ padding: '13px 16px' }}><Badge map={STATUS_COR} k={u.status} /></td>
                      <td style={{ padding: '13px 16px', fontSize: 12.5, color: 'var(--text-muted)' }}>{u.ultimoAcesso ? fmtData(u.ultimoAcesso) : 'nunca'}</td>
                      <td style={{ padding: '13px 16px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                        <div style={{ display: 'inline-flex', gap: 6, alignItems: 'center', justifyContent: 'flex-end' }}>
                          {u.status === 'pendente' && <>
                            {selPapel(u)}
                            <Button size="sm" variant="accent" icon="check" onClick={() => aprovar(u, aprovando[u.id] || 'operador')}>Aprovar</Button>
                            <Button size="sm" variant="ghost" onClick={() => revogar(u)}>Recusar</Button>
                          </>}
                          {u.status === 'ativo' && !eu && !admin && <Button size="sm" variant="ghost" icon="x" onClick={() => revogar(u)}>Revogar</Button>}
                          {u.status === 'ativo' && admin && !eu && <span style={{ fontSize: 11.5, color: 'var(--text-faint)' }}>protegido</span>}
                          {u.status === 'revogado' && <>
                            {selPapel(u)}
                            <Button size="sm" variant="default" icon="refresh" onClick={() => aprovar(u, aprovando[u.id] || 'operador')}>Reativar</Button>
                          </>}
                          {eu && ativo && <span style={{ fontSize: 11.5, color: 'var(--text-faint)' }}>—</span>}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Card>
      )}

      {/* Trilha de logs */}
      {estado === 'ok' && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
            <Icon name="clock" size={17} style={{ color: 'var(--text-muted)' }} />
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: 'var(--text-strong)' }}>Logs de acesso</h3>
            <span style={{ fontSize: 12, color: 'var(--text-faint)' }}>· últimos {logs.length}</span>
          </div>
          <Card pad={0} style={{ overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto', maxHeight: 420, overflowY: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 640 }}>
                <thead><tr style={{ borderBottom: '1px solid var(--border)' }}>
                  {['Quando', 'Ação', 'Quem fez', 'Sobre', 'Detalhe'].map((h, i) => (
                    <th key={i} style={{ textAlign: 'left', padding: '11px 16px', fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.05em', position: 'sticky', top: 0, background: 'var(--surface)' }}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {logs.map((l, i) => {
                    const ai = ACAO_INFO[l.acao] || { txt: l.acao, cor: 'var(--text-muted)', icon: 'clock' };
                    return (
                      <tr key={i} style={{ borderTop: '1px solid var(--border)' }}>
                        <td style={{ padding: '9px 16px', fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{fmtDataHora(l.quando)}</td>
                        <td style={{ padding: '9px 16px' }}>
                          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 700, color: ai.cor }}><Icon name={ai.icon} size={13} /> {ai.txt}</span>
                        </td>
                        <td style={{ padding: '9px 16px', fontSize: 12, color: 'var(--text)' }} className="mono">{l.ator || '—'}</td>
                        <td style={{ padding: '9px 16px', fontSize: 12, color: 'var(--text-muted)' }} className="mono">{l.alvo || '—'}</td>
                        <td style={{ padding: '9px 16px', fontSize: 12, color: 'var(--text-faint)' }}>{l.detalhe || ''}</td>
                      </tr>
                    );
                  })}
                  {!logs.length && <tr><td colSpan={5} style={{ padding: 30, textAlign: 'center', color: 'var(--text-faint)', fontSize: 13 }}>Nenhum registro ainda.</td></tr>}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}

Object.assign(window, { Usuarios });
